import React from "react";
import yellowIndicator from "@src/assets/svg/yellow-indicator-icon.svg";
import { OTAInstallActionButton } from "@src/components/atoms/ota-install-action-button/ota-install-action-button";
import styles from "./ota-backup-process-accept-and-create.module.scss";
import { useOtaBackupProcessAcceptAndCreate } from "./use-ota-backup-process-accept-and-create";
import { ActiveInstallationProcessPayload } from "@src/types/ota-update";

interface OTABackupProcessAcceptAndCreateProps {
  activeInstallationData: ActiveInstallationProcessPayload | null;
}

const cssClassName = "ota-backup-process-accept-and-create";

export default function OTABackupProcessAcceptAndCreate({
  activeInstallationData,
}: OTABackupProcessAcceptAndCreateProps) {
  const { texts, description, handleAcceptAndCreateBackup } =
    useOtaBackupProcessAcceptAndCreate({
      activeInstallationData,
    });

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__content`]}>
        <img
          src={yellowIndicator}
          alt=""
          className={styles[`${cssClassName}__indicator`]}
        />
        <div className={styles[`${cssClassName}__text`]}>
          <span className={styles[`${cssClassName}__title`]}>
            {texts.title}
          </span>
          <span className={styles[`${cssClassName}__description`]}>
            {description}
          </span>
        </div>
      </div>

      <OTAInstallActionButton
        text={texts.acceptAndCreateBackupButtonText}
        variant="primary"
        fun={handleAcceptAndCreateBackup}
      />
    </div>
  );
}
